import React from 'react'
import TableHeader from '../../../../components/table/TableHeader'
import Text from '../../../../components/text/Text'
import TableLayout from '../../../../components/table/TableLayout'
import {IPostList} from '../../../../apis/post/getPostList'
import TableItem from '../../../../components/table/TableItem'
import WizImage from '../../../../components/image/WizImage'
import {useImage} from '../../../../utils/image'
import {useTime} from '../../../../utils/time'
import useNavigation from '../../../../hooks/useNavigation'
import WizButton from '../../../../components/button/WizButton'
import {postEditPost} from '../../../../apis/post/editPost'
import {uploadRecommendApi} from '../../../../apis/recommend/uploadRecommendApi'
import WizTag from '../../../../components/tag/WizTag'

interface IProps {
    className?: string
    data?: IPostList[]
    getNextRank?: () => Promise<number>
    onPinned?: () => void
}

const RecommendPostTable: React.FC<IProps> = ({className, data, getNextRank, onPinned}) => {
    const {renderThumbnail} = useImage()
    const {localTimeString} = useTime()
    const {goPostDetail, goUserDetail} = useNavigation()

    const renderTextVisibility = visibility => {
        if (visibility === 0) {
            return <Text className={'text-ti2 text-font03'}>Only Follower</Text>
        }
        if (visibility === 1) {
            return <Text className={'text-ti2'}>All View</Text>
        }
    }

    const renderTextAction = visibility => {
        if (visibility === 0) {
            return 'Changed to All'
        }
        if (visibility === 1) {
            return 'Changed to Followers'
        }
    }

    const onClickChangedAction = async list => {
        await postEditPost({
            id: list?.id,
            title: list?.title || '',
            content: list?.content || '',
            channel: list?.channel || 'ko',
            visibility: list?.visibility === 0 ? 1 : 0,
            images: list?.images || [],
        }).then(() => {
            alert('Edit Post Complete')
        })
    }

    const onClickUploadPost = async (id: string) => {
        const rank = getNextRank ? await getNextRank() : 1
        await uploadRecommendApi(id, rank).then(res => {
            if (!res?.error) {
                alert('Upload Complete Post')
                onPinned?.()
            } else {
                alert('Error Upload Post')
            }
        })
    }

    const checkScamPost = (list: IPostList) => {
        if (!list?.user.name.match('League of Traders') && (list?.content.match('http') || list?.title.match('http'))) {
            return true
        }
    }

    return (
        <div className={`${className}`}>
            <TableHeader
                className={
                    'grid-cols-[160px_1fr_175px_100px_180px_90px] gap-x-[10px] lg:grid-cols-[160px_1fr_100px_180px_90px] md:hidden'
                }>
                <Text>Writer</Text>
                <Text>Title</Text>
                <Text className={'lg:hidden'}>Create At</Text>
                <Text>View</Text>
                <Text>Action</Text>
                <div></div>
            </TableHeader>
            <TableLayout>
                {data?.map(list => (
                    <TableItem
                        onClick={() => goPostDetail(list?.id)}
                        key={list?.id}
                        className={
                            'grid-cols-[160px_1fr_175px_100px_180px_90px] lg:grid-cols-[160px_1fr_100px_180px_90px] gap-x-[10px] md:block'
                        }>
                        <div
                            className={'flex space-x-[10px] items-center truncate'}
                            onClick={e => {
                                e.stopPropagation()
                                goUserDetail(list?.user?.id)
                            }}>
                            <WizImage
                                src={renderThumbnail(list?.user.thumbnail)}
                                className={'w-[36px] h-[36px] rounded-full'}
                            />
                            <div>
                                <Text className={'text-ti2 truncate'}>{list?.user.name}</Text>
                                <Text className={'text-body3 text-font03 hidden md:block'}>
                                    {localTimeString(list?.created_at)}
                                </Text>
                            </div>
                        </div>
                        <div className={'space-y-[10px] truncate md:mt-[20px] md:pl-[46px]'}>
                            <Text className={`text-ti2 truncate ${checkScamPost(list) && 'text-font_red'}`}>
                                {list?.title}
                            </Text>
                            <div className={'flex items-center'}>
                                <Text className={'truncate text-body2 text-font02'}>{list?.content}</Text>
                                {checkScamPost(list) && <WizTag state={false}>Scam</WizTag>}
                            </div>
                        </div>
                        <div className={'lg:hidden'}>
                            <Text className={'text-body2 text-font02'}>{localTimeString(list?.created_at)}</Text>
                        </div>
                        <div className={'md:text-left md:mt-[20px] sm:text-center'}>
                            {renderTextVisibility(list?.visibility)}
                        </div>
                        <div className={'md:mt-[5px] md:text-left sm:text-center'}>
                            <WizButton
                                text={renderTextAction(list.visibility)}
                                size={'small'}
                                type={'blue'}
                                onClick={e => {
                                    e?.preventDefault()
                                    e?.stopPropagation()
                                    onClickChangedAction(list)
                                }}
                            />
                        </div>
                        <div className={'text-right md:mt-[10px] md:text-left sm:text-center'}>
                            <WizButton
                                text={'Add Pin'}
                                size={'small'}
                                type={'primary'}
                                onClick={e => {
                                    e?.preventDefault()
                                    e?.stopPropagation()
                                    onClickUploadPost(list?.id)
                                }}
                            />
                        </div>
                    </TableItem>
                ))}
            </TableLayout>
        </div>
    )
}

export default RecommendPostTable
